export default "__VITE_ASSET__DeUL4ahc__"